export default __webpack_public_path__ + "static/media/subway.7526dc26.svg";